<app-html-news [news]="news"></app-html-news>

<div class="tables-container">
  <div class="left-table">
    <app-multicup-physics-table
      [physics]="physics.VQ3"
      [physicsTable]="news.vq3Results"
      [multicupId]="news.multicup.id"
      [tableCellsCount]="tableCellsCount"
      data-test-id="multicup-physics-table-vq3"
    >
    </app-multicup-physics-table>
  </div>
  <div class="right-table">
    <app-multicup-physics-table
      [physics]="physics.CPM"
      [physicsTable]="news.cpmResults"
      [multicupId]="news.multicup.id"
      [tableCellsCount]="tableCellsCount"
      data-test-id="multicup-physics-table-cpm"
    >
    </app-multicup-physics-table>
  </div>
</div>
